/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import { Observable, of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { ofType, StateObservable } from 'redux-observable';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import { Action, ActionCreators } from './actions';
import { RootState } from '../index';
import { handleErrorInterceptor } from '../../utils/AuthUtils';

const requestAntennasSuccess = (response: AjaxResponse<any>): any => {
  return ActionCreators.ReceivedAntennasSuccess.create(response);
};

const requestAntennasError = (error: AjaxError): any => {
  return ActionCreators.ReceivedAntennasError.create(error);
};

export const requestAntennasEpic = (
  action$: Observable<Action>,
  state$: StateObservable<RootState>,
  { ajaxRaw }: any,
): Observable<Action> =>
  action$.pipe(
    ofType(ActionCreators.RequestAntennas.type),
    switchMap(
      ($action: any): Observable<Action> =>
        // aircraftTypeId=-1 is needed to obtain the antennas for any generic aircraft. MPT-API requires the field
        ajaxRaw.get('/provisioning/options/antennas?filter').pipe(
          map((response: AjaxResponse<any>): Action => requestAntennasSuccess(response)),
          catchError(
            (error: AjaxError): Observable<Action> =>
              handleErrorInterceptor(
                error,
                of(requestAntennasError(error))
              ),
          ),
        ),
    ),
  );
